import React from "react";
import { Box } from "@mui/material";
import about1 from "../../../assets/landing/about1.png";
import about2 from "../../../assets/landing/about2.png";
import about3 from "../../../assets/landing/about3.png";
import Row from "../../../components/Row";
import ButtonLoading from "../../../components/ButtonLoading";
import { colors } from "../../../utils/constants";
import ArowIcon from "@mui/icons-material/ArrowRightAlt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { landingTokens } from "../theme";
import { openWhatsAppContact } from "../constants";

interface AboutProps {
  isMobile: boolean;
}

function About({ isMobile }: AboutProps) {
  const styles = {
    aboutTitle: {
      fontSize: isMobile ? 22 : 32,
      fontWeight: 600,
      color: colors.primary,
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    aboutContainer: {
      padding: isMobile ? 4 : 12,
      display: "flex",
      justifyContent: "center",
      flexDirection: "column" as const,
      alignItems: "center",
    },
    aboutContentWrapper: {
      position: "relative" as const,
      isolation: "isolate" as const,
      width: "100%",
      maxWidth: 1100,
      margin: "0 auto",
      overflow: "visible",
    },
    decorativeImage: {
      position: "absolute" as const,
      width: 88,
      zIndex: 0,
      pointerEvents: "none" as const,
      display: isMobile ? "none" : "block",
      opacity: 0.95,
      filter: "grayscale(0.4) saturate(0.7) drop-shadow(0 8px 16px rgba(0,40,130,0.25))",
    },
    aboutContent: {
      gap: isMobile ? 20 : 50,
      margin: isMobile ? 20 : 50,
      alignItems: "center",
      justifyContent: "center",
      display: "flex",
      position: "relative" as const,
      zIndex: 1,
      flexDirection: isMobile ? ("column" as const) : ("row" as const),
    },
    aboutBox: {
      position: "relative" as const,
      zIndex: 1,
      background: colors.white,
      border: "1.5px solid #E5E9F0",
      borderRadius: `${landingTokens.radius.card}px`,
      boxShadow: landingTokens.shadow,
      padding: isMobile ? 4 : 6,
      maxWidth: 500,
      textAlign: "center" as const,
      height: isMobile ? "auto" : 300,
      alignItems: "center",
      display: "flex",
    },
    aboutText: {
      textAlign: "center" as const,
      fontSize: isMobile ? 14 : 16,
      color: "#5B6472",
    },
    ctaButton: {
      marginTop: 0,
      color: colors.white,
      backgroundColor: colors.status.green,
      padding: isMobile ? 4 : 12,
      height: isMobile ? 38 : "auto",
      fontSize: isMobile ? 12 : 16,
      width: "100%",
    },
  };

  return (
    <Box sx={styles.aboutContainer}>
      <Box component="span" sx={styles.aboutTitle}>
        <CheckCircleIcon sx={{ color: colors.primary }} /> Sobre
      </Box>

      <Box sx={styles.aboutContentWrapper}>
        <img src={about1} style={{ ...styles.decorativeImage, top: -36, left: -88 }} alt="" />
        <img src={about2} style={{ ...styles.decorativeImage, top: -36, right: -88 }} alt="" />
        <img src={about3} style={{ ...styles.decorativeImage, bottom: -56, left: -64 }} alt="" />

        <Row style={styles.aboutContent}>
          <Box sx={styles.aboutBox}>
            <span style={styles.aboutText}>
              Essa plataforma foi criada com a necessidade dos fundadores da Qazando, Eduardo
              Finotti e Herbert Soares de gerar certificados para seus eventos ao vivo, onde
              tinham muitos problemas, pois tinham que usar ferramentas que não eram propícias
              para a finalidade, não resolvendo seus problemas. Um dos maiores problemas era que
              os participantes não assistiam as aulas ao vivo, mas pediam para gerar o certificado
              posteriormente, assim, não tinha como saber se o aluno participou realmente ou não
              do evento. Para resolver esse problema, foi que criamos a CERTIFY.ME, então agora,
              somente quem realmente assistiu o evento ou aula
            </span>
          </Box>

          <Box sx={styles.aboutBox}>
            <span style={styles.aboutText}>
              por completo terá acesso a senha para fazer checkin no respectivo dia do evento.
              Assim tornando junto e seguro a emissão do certificado para quem realmente
              participou. Além disso, a automação desse processo trouxe muito mais agilidade,
              diminuindo o processo de emissão do certificado para cada aluno (deixando em
              basicamente zero), tendo em vista que é o aluno que emite agora. Ainda, o dono do
              evento possui um dashboard completo com dados do evento e dos participantes. Hoje,
              contamos com mais de 1200 usuários, mais de 3100 checkins realizados e mais de 700
              certificados emitidos com sucesso.
            </span>
          </Box>
        </Row>
      </Box>

      <ButtonLoading
        label="Quero fazer um evento"
        className="landing-hover-lift"
        style={styles.ctaButton}
        endIcon={
          <ArowIcon style={{ marginLeft: isMobile ? 2 : 16, width: isMobile ? 16 : "auto" }} />
        }
        onClick={openWhatsAppContact}
      />
    </Box>
  );
}

export default About;
